export default "__VITE_ASSET__D2CoFLku__"